/**
 * Labstep
 */

import React from 'react';
import type { IModalWizardContextProps } from './types';

export const defaultModalWizardContext = {
  activeStepIndex: 0,
  setActiveStepIndex: () => {
    // Do nothing
  },
  goBack: () => {
    // Do nothing
  },
  goForward: () => {
    // Do nothing
  },
  startIndex: 0,
  isLastStep: false,
  status: undefined,
  errorMessages: [],
  steps: [],
  setErrorMessages: () => {},
};

export const ModalWizardContext =
  React.createContext<IModalWizardContextProps>(
    defaultModalWizardContext,
  );
